import type { Translation } from "../i18n-types.js";

const zh = {
  pay: "支付",
  received: "收到",
  home: {
    payLimit: "最低 {minimum} {currency}，最高 {maximum} {currency}",
    previewOrder: "预览订单",
    selectAToken: "选择代币",
    selectCurrency: "选择货币",
    selectCard: "选择银行卡",
    addDebitOrCreditCard: "添加借记卡或信用卡",
    enterAddress: "输入钱包地址",
    address: "钱包地址",
    inputCard: {
      cardNumber: "卡号",
      expiryDate: "到期日",
      securityCode: "安全码",
      holder: "持卡人姓名",
      action: "添加银行卡",
    },
    buy: "购买 {symbol}",
    sell: "出售 {symbol}",
    swap: "兑换",
    portal: {
      title: "交易",
      swap: "闪兑",
      swapDesc: "按市价即时兑换代币",
      swapHelp: "如何兑换",
      limit: "限价交易",
      limitDesc: "设定价格，到价自动成交",
      perps: "合约交易",
      perpsDesc: "多空双向，支持杠杆",
      fiat: "法币 ⇄ USDT 兑换指南",
      buyDesc: "法币兑换为 USDT",
      sellDesc: "USDT 兑换为法币",
    },
  },
  bankTransferInstruction: {
    title: "银行转账说明",
    menuName: "银行转账",
    desc: [
      "请确认您的银行账户姓名与 KYC 信息一致。",
      "请将上述信息填写到您的银行转账凭证中。",
    ],
    sections: {
      beneficiary: {
        title: "收款人",
        items: {
          remarks: {
            title: "备注",
            desc: "该代码用于识别您的转账，请务必填写。",
          },
          IBAN: "IBAN",
          accountName: "账户名",
          accountNumber: "账号",
          address: "地址",
        },
      },
      beneficiaryBank: {
        title: "收款银行",
        items: {
          BIC_SWIFTCode: "BIC / SWIFT 代码",
          bankName: "银行名称",
          bankAddress: "银行地址",
          bankCity: "银行城市",
          bankCountry: "银行国家",
        },
      },
    },
  },
  payment: {
    method: "支付方式",
    totalToken: "代币数量",
    price: "价格",
    feeByGateway: "网关手续费",
    feeByMixin: "Mixin 手续费",
    feeByNetwork: "网络手续费",
    totalAmount: "总金额",
    destination: "目标地址",
    tips: "您的银行可能会收取额外费用，请联系银行了解详情。",
  },
  login: {
    action: "使用 Mixin 登录",
    actionWithPreorder: "授权",
    actionWithEmail: "使用邮箱继续",
    email: {
      otherLoginOptions: "← 其他登录方式",
      title: "登录 Mixin Route",
      actionWithSend: "发送验证码",
      verificate: "验证验证码",

      emailPlaceholder: "邮箱地址",
      securityCodePlaceholder: "验证码",

      verificateCodeTips: "请输入发送到 {email} 的验证码",
    },
  },
  order: {
    detail: "订单详情",
    payment: {
      fetching: "获取订单中",
      failed: "支付失败",
      paying: "支付中",
      success: "支付完成",
      successDesc: "支付完成后，代币将直接转入您的钱包。",
      expired: "价格已过期",
    },
    status: {
      returnTo: "返回 {name}",
      created: "待支付",
      paying: "进行中",
      success: "成功",
      failed: "失败",
    },
    useLatestPrice: "使用最新价格",
  },
  orders: {
    title: "订单",
    boughtSome: "购入 {symbol}",
  },
  card: {
    visa: "Visa",
    mastercard: "Mastercard",
  },
  kyc: "KYC",
  copyKycLink: "复制 KYC 链接",
  status: "状态",
  name: "Mixin Route",
  slogan: "立即购买加密货币到您的钱包",
  delete: "删除",
  done: "完成",
  cancel: "取消",
  retry: "重试",
  back: "返回",
  copied: "已复制",
  error: {
    10608: "持卡人姓名与您的姓名不匹配。",
    10610: "国家信息不一致，请联系客服。",
    20111: "邮件发送过于频繁，请稍后重试。",
    20113: "无效的验证码。",
    20114: "验证码已过期，请重新发送。",
    20115: "钱包地址无效。",
    20116: "价格报价已过期。",
    addCard: "添加银行卡失败。",
    quote: "获取最新报价失败，价格可能已过期。",
    auth: "认证失败，详情：{error}",
    kycBlocked: "身份验证失败，请联系客服。",
    pay: "支付失败，请重试。",

    unknown: "未知错误，请稍后重试。",
    notFound: "未找到",
    timeout: "网络超时，请稍后重试。",
    params: "参数错误。",

    copy: "复制到剪贴板失败",
    10601: "卡片已过期。",
    10602: "价格报价已过期。",
    10604: "不支持的卡片，请尝试其他卡片。",
    10605: "卡片同时被使用。",
    10606: "尝试次数过多，请稍后重试。",
    10607: "添加的卡片过多。",
    10609: "会话已过期。",
    network: "网络错误，请稍后重试。",
  },
  form: {
    required: "必填。",
    email: "无效的邮箱地址。",
  },
  onramp: {
    poweredBy: "Powered by Coinbase",
    loginTitle: "登录以继续",
    loginDesc: "立即登录，通过 Apple Pay 购买加密货币。",
    continueWithApple: " 使用 Apple 继续",
    agreementText: "继续即表示您同意 <>隐私政策</> 和 <>服务条款</>。",
    missingParameters: "缺少参数",
    assetNotFound: "未找到资产",
    orderConfirm: "确认订单",
    transactionError: "处理该交易时出现问题，请稍后重试。",
    paymentSuccess:
      "支付成功。您的 {amount} {symbol} 将很快直接转入您的 Mixin 钱包，请耐心等待。",
    tokenAmount: "代币数量",
    bankFeeTips:
      "您的银行可能会收取额外费用，请联系银行了解详情。",
    processing: "处理中",
    applePayPurchase: "Apple Pay 购买",
    creatingOrder: "创建订单中…",
    loadingPayment: "请稍候，支付页面正在加载…",
    loadingPaymentData: "获取支付数据中…",
    loadingPaymentDomReady: "请稍候，支付页面正在初始化…",
    waitingPaymentReady: "请稍候，正在连接支付页面…",
    processingPayment: "支付处理中…",
    waitingToCreateOrder: "正在等待创建订单…",
    orderCreationFailed: "创建订单失败",
    paymentLoadFailed: "加载支付页面失败",
    paymentCommitFailed: "提交支付失败",
    paymentFailed: "支付失败",
    failedBillingHint: "请确保 Apple Pay 账单信息正确",
    useOtherPaymentMethod: "使用其他支付方式",
    limitReached: "交易已达上限，完成验证提升额度或使用其他支付方式。",
    upgradeLimit: "提升额度",
    startVerification: "开始验证",
    cancelVerification: "取消",
    verifyIdentity: "身份验证",
    verifyIdentityPending: "身份验证中",
    verifyingIdentityDesc:
      "身份验证正在处理中。验证完成后，我们会通过消息通知您。",
    gotIt: "知道了",
    last4Ssn: "社保号后 4 位",
    birthOfDate: "出生日期",
    verificationGuideDesc:
      "基于合规与安全原因，提升额度需要验证你的社会安全号码和出生日期，完成验证后：",
    verificationGuideItem1: "周额度提升至 2500 美金。",
    verificationGuideItem2: "购买次数提升至无限次。",
    verificationFormDesc:
      "基于合规与安全原因，我们需要验证你的社保号后 4 位和出生日期。",
    formErrorSsnLast4: "请输入 4 位数字的社保号后 4 位。",
    formErrorBirthDate: "请选择出生日期。",
    limitUpgradeFailed: "提交身份验证失败，请稍后重试。",
    errorCodes: {
      ERROR_CODE_INIT: "支付链接无效或已过期，请重新创建订单。",
      ERROR_CODE_GUEST_APPLE_PAY_NOT_SUPPORTED:
        "当前浏览器或设备不支持 Apple Pay。",
      ERROR_CODE_GUEST_APPLE_PAY_NOT_SETUP:
        "此设备尚未设置 Apple Pay，请先完成设置后重试。",
      ERROR_CODE_GUEST_CARD_SOFT_DECLINED:
        "银行拒绝了此次支付，请尝试其他银行卡。",
      ERROR_CODE_GUEST_INVALID_CARD: "银行卡信息或账单地址无效，请检查后重试。",
      ERROR_CODE_GUEST_CARD_INSUFFICIENT_BALANCE: "银行卡余额不足。",
      ERROR_CODE_GUEST_CARD_HARD_DECLINED:
        "发卡行拒绝了此次支付，请尝试其他银行卡。",
      ERROR_CODE_GUEST_CARD_RISK_DECLINED: "支付因风控被拦截，无法继续。",
      ERROR_CODE_GUEST_REGION_MISMATCH: "当前地区不支持。",
      ERROR_CODE_GUEST_PERMISSION_DENIED: "该账户已被禁止使用入金服务。",
      ERROR_CODE_GUEST_CARD_PREPAID_DECLINED:
        "不支持预付费借记卡，请更换银行卡。",
      ERROR_CODE_GUEST_TRANSACTION_LIMIT: "超出每周交易额度限制。",
      ERROR_CODE_GUEST_TRANSACTION_COUNT: "超出累计交易次数限制。",
      ERROR_CODE_GUEST_TRANSACTION_BUY_FAILED:
        "加密货币购买失败，银行卡不会被扣款。",
      ERROR_CODE_GUEST_TRANSACTION_SEND_FAILED:
        "向目标地址转账失败，银行卡将被退款。",
      ERROR_CODE_GUEST_TRANSACTION_TRANSACTION_FAILED:
        "处理交易时发生内部错误。",
      ERROR_CODE_GUEST_TRANSACTION_AVS_VALIDATION_FAILED:
        "账单地址校验失败，请向银行确认地址信息。",
    },
  },
} satisfies Translation;

export default zh;
